import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiConnectService } from './api-connect.service';
import {
  EmployeeStandardMatrixRequest,
  EmployeeStandardMatrixResponse,
  EmployeeStandardUpdateRequest,
  StandardAssignmentCleanupState,
  EmployeeStandardUserResponse
} from '../models/employee-standard-overrides.model';
import {Standard} from '../models/standard.model';
import {standardResponseWithVersion, standardVersionHeaders} from './standard-version';

const STANDARD_PATH_SEPARATOR = '/';
const STANDARD_CLEANUP_PATH = '/assignment-cleanup';
const STANDARD_CLEANUP_RESUME_PATH = '/resume';
const STANDARD_RESPONSE = 'response';

@Injectable()
export class EmployeeStandardOverridesService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiConnectService: ApiConnectService
  ) {}

  public fetchGroupUsers(groupId: string): Observable<EmployeeStandardUserResponse[]> {
    return this.http.get<EmployeeStandardUserResponse[]>(
      this.createBaseUrl(groupId) + '/users'
    );
  }

  public fetchMatrix(
    groupId: string,
    request: EmployeeStandardMatrixRequest
  ): Observable<EmployeeStandardMatrixResponse> {
    return this.http.post<EmployeeStandardMatrixResponse>(
      this.createBaseUrl(groupId) + '/matrix',
      request
    );
  }

  public updateAssignments(
    groupId: string,
    request: EmployeeStandardUpdateRequest
  ): Observable<string> {
    return this.http.patch(
      this.createBaseUrl(groupId),
      request,
      { responseType: 'text' }
    );
  }

  public fetchCleanupStatus(standardId: string): Observable<HttpResponse<StandardAssignmentCleanupState>> {
    return this.http.get<StandardAssignmentCleanupState>(this.cleanupUrl(standardId), { observe: STANDARD_RESPONSE })
      .map(standardResponseWithVersion);
  }

  public resumeCleanup(state: StandardAssignmentCleanupState): Observable<HttpResponse<Standard>> {
    return this.http.post<Standard>(this.cleanupUrl(state.standardId) + STANDARD_CLEANUP_RESUME_PATH, null,
      { observe: STANDARD_RESPONSE, headers: standardVersionHeaders(state) }).map(standardResponseWithVersion);
  }

  private cleanupUrl(standardId: string): string {
    return this.apiConnectService.createHeadStandard + STANDARD_PATH_SEPARATOR + standardId + STANDARD_CLEANUP_PATH;
  }

  private createBaseUrl(groupId: string): string {
    return this.apiConnectService.employeeStandardOverrides +
      groupId +
      '/standards/employee-overrides';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/employee-standard-overrides.service.ts